import React from 'react';

import ContactsPage from '../components/pages/contacts/Index';
import { isBrowser } from '../helpers/formatPrice';
import Storage from '../helpers/storage';
import {
  STORAGE_NAVBAR,
  STORAGE_SETTINGS,
  STORAGE_CONTACTS,
  SITE_INFO_CONTACTS,
  SITE_INFO_NAVBAR,
  SITE_INFO_SETTINGS,
} from '../helpers/constants';
import Api from '../helpers/api';

export default class ContactsPageWrapper extends React.Component {
    static getInitialProps = async ({ req }) => {
      if (isBrowser()) {
        const navbar = Storage.get(STORAGE_NAVBAR);
        const settings = Storage.get(STORAGE_SETTINGS);
        const contacts = Storage.get(STORAGE_CONTACTS);

        if (navbar && settings && contacts) {
          return { navbar, settings, contacts };
        }
      }

      const api = new Api({ domain: req ? req.headers.host : null });
      const siteinfo = await api.getSiteInfo([SITE_INFO_CONTACTS, SITE_INFO_NAVBAR, SITE_INFO_SETTINGS]);

      return siteinfo;
    }

    render() {
      return (
        <ContactsPage {...this.props} />
      );
    }
}
